import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ApprovePropsType = {
  onClick: () => void;
};

export const Approve: React.FC<ApprovePropsType> = ({ onClick }) => {
  const { t } = useTranslation('common');

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const label = t('ACTIONS.APPROVE');

  return (
    <Tooltip label={label}>
      <UnstyledButton onClick={handleClick} aria-label={label}>
        <FontAwesomeIcon
          icon={faCircleCheck}
          color="var(--mantine-color-green-7)"
        />
      </UnstyledButton>
    </Tooltip>
  );
};
